import styled from "styled-components";
import propTypes from "@styled-system/prop-types";
import { space } from "styled-system";

const LoadingRing = styled.div`
  display: inline-block;
  position: relative;
  width: ${props => `${props.width || 80}px`};
  height: ${props => `${props.width || 80}px`};

  /* Style system support */
  ${space}
  
  div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: ${props => `${(props.width || 80) * 0.8}px`};
    height: ${props => `${(props.width || 80) * 0.8}px`};
    margin: ${props => `${(props.width || 80) * 0.1}px`};
    border: ${props => `${(props.width || 80) * 0.1}px`} solid ${props => props.color || "#fff"};
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${props => props.color || "#fff"} transparent transparent transparent;
      
    &:nth-child(1) {
      animation-delay: -0.45s;
    }
      
    &:nth-child(2) {
      animation-delay: -0.3s;
    }
      
    &:nth-child(3) {
      animation-delay: -0.15s;
    }
  }
  
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

LoadingRing.propTypes = {
  width: propTypes.layout.width,
  ...propTypes.space,
};

export { LoadingRing };
